import { makeStyles } from '@mui/styles'
import React from 'react'
import PropTypes from 'prop-types'

const useStyles = makeStyles({
    root: {
        height: '141px',
        width: '192px',
        border: 'none',
        borderRadius: '6px',
        padding: '20px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        rowGap: '1rem',
        backgroundColor: '#ffffff',
        color: '#000648',
        cursor: 'pointer',
        boxShadow: '#908a8a 6px 6px 7px',
        '&:hover': {
            transition: '0.6s',
            transform: 'scale(1.05)'
        }
    },
    root02: {
        border: '3px solid #FF4F21',
        // transform: 'scale(1.10)'
    },
    typo03: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '18px'
    },
    "@media (max-width: 960px)": {
        root: {
            height: '100px',
            width: '136px',
            padding: '12px 8px',
        },
        typo03: {
            fontFamily: 'Poppins',
            textAlign: 'center',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '14px',
            color: '#000648'
        },
    }
})

function IconTextCard({ icon, text, onClick, selectedDiv }) {
    const classes = useStyles({ icon, text })
    return (
        <>
            <button
                className={selectedDiv ? `${classes.root} ${classes.root02}` : `${classes.root}`}
                onClick={() => onClick()}
            >
                {icon}
                <span className={classes.typo03}>{text}</span>
            </button>
        </>
    )
}

IconTextCard.propTypes = {
    icon: PropTypes.node,
    text: PropTypes.string,
    onClick: PropTypes.any,
    selectedDiv: PropTypes.bool
}

export default IconTextCard
